import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
@Component({
  selector: 'app-value-stream-master',
  templateUrl: './value-stream-master.component.html',
  styleUrls: ['./value-stream-master.component.scss']
})
export class ValueStreamMasterComponent implements OnInit {
  date: any;
  submitButton: string = 'Submit'
  manufactureTable: any = [];
  myDate: any;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(private _apiService: ApiServiceService, private _utility: AppUtility , private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.getAllTableData();
  }

  breadcrumb = [
    {
      title: 'Value Stream',
      subTitle: 'Dashboard'
    }
  ]

  valuesteamform = new FormGroup({
    valuestreamName: new FormControl('', [Validators.required]),
    SGST: new FormControl(''),
    IGST: new FormControl(''),
    CGST: new FormControl(''),

  })

  valuesteamformSubmit(manufacture: FormGroupDirective) {
    console.log(this.valuesteamform.value);
    if (this.valuesteamform.valid) {
      this._utility.loader(true);
      let object = this.valuesteamform.value;
      if (this.submitButton == 'Submit') {
        this._apiService.addvaluestream(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.valuesteamform.reset();
            // ;          
            Object.keys(this.valuesteamform.controls).forEach(key => {
              this.valuesteamform.controls[key].setErrors(null)
            });
            manufacture.resetForm();
            this.getAllTableData();

          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }

        })
      }
      else {
        object['valueStreamId'] = this.editItemId;
        console.log(object);
        this._apiService.editvaluestream(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.valuesteamform.reset();
            Object.keys(this.valuesteamform.controls).forEach(key => {
              this.valuesteamform.controls[key].setErrors(null)
            });
            manufacture.resetForm();
            this.submitButton = 'Submit'
            this.getAllTableData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }

  editItemId: any;
  EditItem(customer: any) {
    console.log(customer);
    if (customer.valueStreamId) {
      console.log(customer.valueStreamId);
        console.log(this.valuesteamform.controls);
        
     this.valuesteamform.patchValue({
      valuestreamName: customer.valueStreamName 
    });
      this.submitButton = 'Update'
      this.editItemId = customer.valueStreamId;
      console.log(this.editItemId);
      
    }
  }

  getAllTableData() {
    this._utility.loader(true);
    this._apiService.getvaluestream()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          this.manufactureTable = res.returnValue;
        }
        else {
          this.manufactureTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.manufactureTable = [];
      })
  }

  confirm1(costBreakupId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete Other Category Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(costBreakupId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(itemId: any) {
    this._utility.loader(true);
    this._apiService.deletevaluestream(itemId)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getAllTableData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getAllTableData();
      }

    })
  }
   keyPress(event: KeyboardEvent) {
  const allowedPattern = /^[0-9+\-.,%]*$/;

  const input = event.target as HTMLInputElement;
  const inputValue = input.value;
  const char = String.fromCharCode(event.charCode);

  const proposedValue = inputValue + char;

  if (!allowedPattern.test(proposedValue)) {
    event.preventDefault();
  }
}

}
